var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15513 11.1426H1.01763V4.26888H3.15513V11.1426ZM2.08638 3.33232C1.40013 3.33232 0.846069 2.77825 0.846069 2.09482C0.846069 1.41138 1.40013 0.857315 2.08638 0.857315C2.76982 0.857315 3.32388 1.41138 3.32388 2.09482C3.32388 2.77544 2.76982 3.33232 2.08638 3.33232ZM11.1539 11.1426H9.01919V7.80138C9.01919 7.00544 9.00513 5.97888 7.90826 5.97888C6.79732 5.97888 6.62857 6.84794 6.62857 7.74513V11.1426H4.49669V4.26888H6.54419V5.20825H6.57232C6.85638 4.66825 7.55388 4.09732 8.5917 4.09732C10.7545 4.09732 11.1539 5.52044 11.1539 7.37107V11.1426Z",
    fill: "url(#paint0_linear_385_15212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_15212",
    x1: 5.99998,
    y1: 0.857315,
    x2: 5.99998,
    y2: 11.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4b7de6a999231981bed402b03537c864.svg";
export { ForwardRef as ReactComponent };